import { InputBase, InputLabel, styled } from "@mui/material";
import pxToRem from "theme/base/pxToRem";

export const Input = styled(InputBase)<{ fontWeight?: number }>(
  ({ theme, fontWeight }) => ({
    "label + &": {
      marginTop: pxToRem(26),
    },
    padding: `${pxToRem(10)} ${pxToRem(12)}`,
    borderRadius: pxToRem(8),
    border: `1px solid ${theme.palette.stroke.strokeDefault}`,
    fontSize: pxToRem(16),
    lineHeight: pxToRem(16),
    fontWeight: fontWeight ?? theme.typography.fw_regular_400,
    backgroundColor: `${theme.palette.background.bgPrimary}`,

    "& input": {
      padding: 0,
      "&::-ms-reveal": {
        display: "none",
      },
      "&::-ms-clear": {
        display: "none",
      },
    },
    "&.Mui-error": {
      borderColor: `${theme.palette.text.textNegative} !important`,
    },
    "&.Mui-disabled": {
      backgroundColor: theme.palette.background.bgTertiary,
      borderColor: theme.palette.background.bgTertiary,
    },
    "& input:-webkit-autofill": {
      "-webkit-box-shadow": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
      "-webkit-text-fill-color": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
    },
    "& input:-webkit-autofill:focus": {
      "-webkit-box-shadow": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
      "-webkit-text-fill-color": `0 0 0 50px ${theme.palette.background.bgPrimary} inset`,
    },
    "&:focus-within": {
      borderColor: theme.palette.stroke.strokeBrand,
    },
  })
);

export const Label = styled(InputLabel)<{ disabled?: boolean }>(
  ({ theme, disabled = false }) => ({
    fontSize: pxToRem(16),
    lineHeight: theme.typography.lineHeight.sm,
    fontWeight: theme.typography.fw_regular_400,
    color: disabled
      ? theme.palette.text.textSecondary
      : theme.palette.text.textPrimary,
    display: "flex",
    alignItems: "center",
    transform: "none",
    gap: pxToRem(8),

    "&.Mui-focused": {
      color: disabled
        ? theme.palette.text.textSecondary
        : theme.palette.stroke.strokeBrand,
    },
  })
);

export const Required = styled("span")<{ disabled?: boolean }>(({ theme }) => ({
  color: theme.palette.colorsBase.red_0,
  marginLeft: pxToRem(-4),
}));
